<template>
  <v-col :style="timeInputStyle">
    <v-menu
      v-model="menu"
      :close-on-content-click="false"
      :nudge-right="40"
      transition="scale-transition"
      offset-y
      min-width="290px"
    >
      <template v-slot:activator="{ on }">
        <v-text-field
          class="date-input"
          :label="label"
          prepend-icon="fa-regular fa-clock"
          readonly
          outlined
          hide-details
          :value="range ? rangeText : value"
          v-on="on"
          :clearable="clearable || false"
          @input="updateValue"
          :tabindex="tabstop ? '' : tabindex || 1"
        ></v-text-field>
      </template>
      <v-time-picker
        format="24hr"
        scrollable
        color="primary"
        locale="pt-br"
        :max="range ? value[1] : null"
        :v-bind="$attrs"
        :value="range ? value[0] : value"
        @input="updateStartTime"
      />
      <v-time-picker
        v-show="range"
        format="24hr"
        scrollable
        color="primary"
        locale="pt-br"
        :min="value[0]"
        :v-bind="$attrs"
        :value="value[1]"
        @input="updateEndTime"
      />
    </v-menu>
  </v-col>
</template>

<script>
export default {
  data() {
    return {
      menu: false,
    };
  },

  props: [
    "value",
    "range",
    "label",
    "clearable",
    "width",
    "tabstop",
    "tabindex",
  ],

  computed: {
    rangeText() {
      return this.value.join(" ~ ");
    },

    timeInputStyle() {
      return this.width
        ? {
            "min-width": this.width + " !important",
            "max-width": this.width + " !important",
          }
        : {
            "min-width": this.range
              ? this.clearable
                ? "220px"
                : "210px"
              : this.clearable
              ? "170px"
              : "140px",
            "max-width": this.range
              ? this.clearable
                ? "220px"
                : "210px"
              : this.clearable
              ? "170px"
              : "140px",
          };
    },
  },

  methods: {
    updateStartTime: function (value) {
      this.$emit("input", this.range ? [value, this.value[1]] : value);
    },

    updateEndTime: function (value) {
      this.$emit("input", [this.value[0], value]);
    },

    updateValue: function () {
      this.$emit("input", this.range ? ["", ""] : "");
    },
  },
};
</script>
